import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { PASSWORD_REGEX } from '../../constantes/passwordConstants';
import { RequirementItem, RequirementsContainer } from './PasswordStrengthChecker.styles';
import { Typography } from '../../../../components/ds';

const {Text} = Typography;

const RequirementCheck = ({isValid, children}: any) => (
  <RequirementItem>
    {isValid ? (
      <CheckOutlined style={{color: 'green', marginRight: 8}}/>
    ) : (
      <CloseOutlined style={{color: 'red', marginRight: 8}}/>
    )}
    <Text type={isValid ? 'success' : 'danger'}>{children}</Text>
  </RequirementItem>
);

const PasswordStrengthChecker = ({password}: any) => (
  <RequirementsContainer>
    <RequirementCheck isValid={password.length >= 8}>
      Sua senha deve conter no mínimo 8 caracteres com:
    </RequirementCheck>
    <RequirementCheck isValid={PASSWORD_REGEX.UPPERCASE.test(password)}>
      Uma letra maiúscula
    </RequirementCheck>
    <RequirementCheck isValid={PASSWORD_REGEX.LOWERCASE.test(password)}>
      Uma letra minúscula
    </RequirementCheck>
    <RequirementCheck isValid={PASSWORD_REGEX.SPECIAL_CHAR.test(password)}>
      {'Um caractere especial (Ex: !@#$%^&*(),.?":{}|<>)'}
    </RequirementCheck>
    <RequirementCheck isValid={PASSWORD_REGEX.NUMBER.test(password)}>
      Um número
    </RequirementCheck>
  </RequirementsContainer>
);

export default PasswordStrengthChecker;
